
import React, { useEffect, useState } from 'react'
import ReactDOM from 'react-dom'
import './index.less'
console.log(React)

export default function Mantle(props) {
  const [ifon, setIfon] = useState({
    div: null
  })

  useEffect(() => {
    const div = document.createElement('div')
    const body = document.querySelector('body')
    const children = props.children ? props.children : null
    div.classList.add('Mantle')
    div.style.backgroundColor = props.baColor
    ReactDOM.render(children, div)
    body.appendChild(div)
    setIfon({
      ...ifon,
      div: div
    })

    return () => {
      ReactDOM.unmountComponentAtNode(div)
      div.remove()
    }
  }, [props.is])

  return null
}
